module.exports = __webpack_public_path__ + "img/light_brown.47d47312.svg";